import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { Badge } from '@/components/Badge';

export function HealthBadge({ healthy }: { healthy: boolean }) {
    const { t } = useTranslation(I18nNamespace.SETTINGS);

    return (
        <Badge variant={healthy ? 'positive' : 'negative'}>
            {t(`license.healthValues.${healthy ? 'connected' : 'unreachable'}`)}
        </Badge>
    );
}
